const _converter = {
  convert(b) {
    let url = "";
    let pre = "data:image/jpg;base64,";
    url = pre + b;
    return url;
  }
};

export default _converter;
